import { ComponentProps } from 'react';
import { StyleSheet } from 'react-native';

import { MenuItem, MenuItemProps } from '../../Menu';
import { colors, spacing } from '../../../theme';
import { Text } from '../../Text';

export const ModalMenuItem = ({
	title,
	status,
	style,
	disabled,
	...itemProps
}: ModalMenuItemProps) => (
	<MenuItem
		disabled={disabled}
		title={() => (
			<Text
				category="h5"
				align="center"
				disabled={disabled}
				style={styles.menuItemText}
				status={status}
			>
				{title}
			</Text>
		)}
		style={[styles.menuItem, style]}
		{...itemProps}
	/>
);

const styles = StyleSheet.create({
	menuItem: { backgroundColor: colors.transparent, paddingVertical: spacing(2) },
	menuItemText: {
		fontSize: 18,
		flex: 1,
	},
});

export type ModalMenuItemProps = MenuItemProps & Pick<ComponentProps<typeof Text>, 'status'>;
